import React from 'react'
import { useNavigate } from 'react-router-dom'

import { BaseView } from '@/components/base'
import { AssetItem } from './components/AssetItem'
import { useUserStore } from '@/store'

export const AssetsList: React.FC = () => {
  const navigate = useNavigate()
  const completeCurrencies = useUserStore(
    (state) => state.wallet?.completeCurrencies,
  )

  const handleAssetPress = (currency: any) => {
    navigate('/currency-details', {
      state: { ...currency },
    })
  }

  // Filter currencies to show only those with balance > 0
  const onlyCurrenciesWithAmount =
    completeCurrencies?.filter((currency) => currency.fiatAmount > 0) || []

  return (
    <BaseView style={{ gap: '1.5px' }}>
      {onlyCurrenciesWithAmount.map((currency, index) => {
        const isFirstItem = onlyCurrenciesWithAmount.length > 1 && index === 0
        const isLastItem =
          onlyCurrenciesWithAmount.length > 1 &&
          index === onlyCurrenciesWithAmount.length - 1
        const haveOnlyOneItem = onlyCurrenciesWithAmount.length === 1

        return (
          <AssetItem
            key={currency.id}
            {...currency}
            onPress={() => handleAssetPress(currency)}
            isFirstItem={isFirstItem}
            isLastItem={isLastItem}
            haveOnlyOneItem={haveOnlyOneItem}
          />
        )
      })}
    </BaseView>
  )
}
